export const PREMIUM_TRIAL_CAMPAIGN_SLUG = "ela-sci-ss-trial-2026";

export const PREMIUM_TRIAL_CAMPAIGN_SLUG_LAST_YEAR = "ela-sci-ss-trial-2025";

export const NCE_ALL_ACCESS_TRIAL_CAMPAIGN_TITLE = "NCE-2026-180-AllAccess";

export const NCE_TRIAL_CAMPAIGN_TITLES = [NCE_ALL_ACCESS_TRIAL_CAMPAIGN_TITLE];

export const ACTIVE_TRIAL_LICENSES = [
  PREMIUM_TRIAL_CAMPAIGN_SLUG,
  PREMIUM_TRIAL_CAMPAIGN_SLUG_LAST_YEAR,
  ...NCE_TRIAL_CAMPAIGN_TITLES,
];
